import {CLEAR_YEAR_NOTIFICATION_BUBBLE} from "../../../../../enums/Employees/employees.types";

export const clearPendingRequestInfoAction = () => {
    return {
        type: CLEAR_YEAR_NOTIFICATION_BUBBLE,
    };
};